import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Download() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header isHomePage={false} />

      <section className="relative w-full h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-screen">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="/assets/downloadPageNew.png"
            alt="Download"
            className="w-full h-full object-cover object-center"
            loading="lazy"
          />
          
          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-black/20"></div>
        </div>

        <div className="relative z-10 flex flex-col justify-center items-start h-full">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
            <div className="max-w-lg lg:max-w-xl xl:max-w-2xl text-left">
              <h1 className="text-white font-semibold font-poppins text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-tight sm:leading-tight md:leading-tight lg:leading-tight xl:leading-tight">
                <span className="block mb-0 sm:mb-1 md:mb-2 lg:mb-3">{t("DownloadNowNew")}</span>
                <span className="block mb-0 sm:mb-1 md:mb-2 lg:mb-3">{t("DownloadNowNew2")}</span>
                <span className="block">{t("DownloadNowNew3")}</span>
              </h1>

              <p className="text-white/90 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl mt-4 sm:mt-5 md:mt-6 lg:mt-8 max-w-xl">
                {t("DownloadNowDesc")}
              </p>

              <div className="flex flex-wrap gap-3 sm:gap-4 mt-6 sm:mt-8 md:mt-10 lg:mt-12">
                <a
                  href="https://apps.apple.com/app/id6469883509"
                  className="transform hover:scale-105 transition-transform duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/appStore.svg"
                    alt="Download on App Store"
                    className="h-20 sm:h-24 md:h-28 lg:h-32 xl:h-36 w-auto"
                    loading="lazy"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.example.app"
                  className="transform hover:scale-105 transition-transform duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/googlePlay.svg"
                    alt="Get it on Google Play"
                    className="h-20 sm:h-24 md:h-28 lg:h-32 xl:h-36 w-auto"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer isHomePage={false} />
    </div>
  );
}
